//@flow
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core';
import type {MessageMultimedia} from '../../../../../../../../entities';
import ImageRenderer from '../../../../../../../../elements/ImageRenderer';
import DownloadIcon from '../../../../../../../../elements/icons/DownloadIcon';
import {colors} from '../../../../../../../../assets/styles/colors';
import {fetchWhatsappApiMedia} from '../../../../../utils/message';
import {useCurrentConversation} from '../../../../../utils/conversation';
import InlineLoader from '../../../../../../../../elements/LoadingSpinner/InlineLoader';

import fallbackImage from '../../../../../../../../assets/img/addImage.png';

const useStyles = makeStyles(theme => ({
  pictureMessage: {
    width: '100%',
    height: '80px',
    borderRadius: '.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',

    '&[data-single="true"]': {
      height: 'auto !important',
    },

    [theme.breakpoints.up('xl')]: {
      height: '120px',
    },

    '&:nth-child(1)': {
      gridColumn: '1 / 3',
    },

    '&:nth-child(2)': {
      gridColumn: '3 / 4',
    },

    '&:nth-child(3)': {
      gridColumn: '1 / 2',
    },

    '&:nth-child(4)': {
      gridColumn: '2 / 4',
    },

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform .2s ease-in-out',
      borderRadius: 'inherit',
    },

    '&:hover img': {
      transform: 'scale(1.1)',
    },
  },
  downloadIcon: {
    width: '60px',
    height: '60px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '2rem',
    background: colors.lightPurple,
    color: colors.primary,
    borderRadius: '.75rem',
  },
  loader: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    background: 'rgba(255, 255, 255, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },
}));

type Props = {
  image: MessageMultimedia,
  self: boolean,
  single: boolean,
  onClick: (src: string | Blob) => void,
};
export default function ImageMessage({image, self, single, onClick}: Props) {
  const classes = useStyles();
  const {currentConversation} = useCurrentConversation();

  const [src, setSrc] = useState(image.src);
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (!currentConversation) return;
    if (image.src) {
      onClick(image.src);
    }

    if (image.mediaId) {
      setLoading(true);
      fetchWhatsappApiMedia(currentConversation.deviceId, image?.mediaId || '')
        .then(source => {
          setSrc(source);
        })
        .catch(() => {
          setSrc(fallbackImage);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <button
      className={classes.pictureMessage}
      onClick={handleClick}
      data-single={single}
    >
      {src ? (
        <ImageRenderer src={src} alt="" />
      ) : (
        <span className={classes.downloadIcon}>
          <DownloadIcon />
        </span>
      )}
      {loading && (
        <InlineLoader loading={loading} className={classes.loader} size={40} />
      )}
    </button>
  );
}
